// @ts-strict-ignore
import { ChartTypeRegistry, ChartEvent, LegendItem, LegendElement } from "chart.js";

import { ChartConfiguration } from "components/ui/Chart/chart.types";
import { baseChartOptions } from "components/ui/Chart/configurations/chart-configurations/base.chart-configuration";
import { createLegendConfiguration } from "components/ui/Chart/configurations/plugins/legend.plugin-configuration";
import { createTooltipConfiguration } from "components/ui/Chart/configurations/plugins/tooltip.plugin-configuration";
import { createVerticalLinePlugin } from "components/ui/Chart/plugins";

export const createVisibilityToggleHandler = (setVisibilityFilter) =>
    function <TType extends keyof ChartTypeRegistry>(
        e: ChartEvent,
        legendItem: LegendItem,
        legend: LegendElement<TType>
    ): void {
        const index = legendItem.datasetIndex;
        const ci = legend.chart;
        if (ci.isDatasetVisible(index!)) {
            ci.hide(index!);
            legendItem.hidden = true;
            setVisibilityFilter((prev) => [...prev, legendItem.text]);
        } else {
            ci.show(index!);
            legendItem.hidden = false;
            setVisibilityFilter((prev) => prev.filter((text) => text !== legendItem.text));
        }
    };

export const lineChartConfiguration: ChartConfiguration<"line"> = {
    type: "line",
    options: {
        ...baseChartOptions,
        elements: {
            point: { radius: 0 },
            line: {
                borderWidth: 1,
            },
            bar: {
                borderRadius: 4,
            },
        },
        hover: {
            mode: "index",
            intersect: false,
        },
        scales: {},
        plugins: {
            legend: createLegendConfiguration(),
            tooltip: createTooltipConfiguration(),
        },
    } as ChartConfiguration<"line">["options"],
    plugins: [createVerticalLinePlugin()],
};

export type CreateLineChartConfigurationOptions = {
    scales: ChartConfiguration<"line">["options"]["scales"];
    plugins?: ChartConfiguration<"line">["options"]["plugins"];
    legendOnClick?: (e: ChartEvent, legendItem: LegendItem, legend: LegendElement<"line">) => void;
};
export const createLineChartConfiguration = (
    options: CreateLineChartConfigurationOptions
): ChartConfiguration<"line"> => {
    return {
        ...lineChartConfiguration,
        options: {
            ...lineChartConfiguration.options,
            scales: options.scales,
            plugins: {
                ...lineChartConfiguration.options.plugins,
                ...options.plugins,
                legend: {
                    ...lineChartConfiguration.options.plugins?.legend,
                    onClick: options.legendOnClick,
                },
            },
        },
    };
};
